import React, { useState } from 'react';
import { Download, ChevronDown } from 'lucide-react';
import * as Select from '@radix-ui/react-select';

export function ExportButton() {
  const [loading, setLoading] = useState(false);
  const [format, setFormat] = useState<'csv' | 'json'>('csv');

  const handleExport = async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/analyses/export/feedback.${format}`);
      if (!response.ok) throw new Error('Export failed');

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `sentinel-feedback-export.${format}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'inline-flex', gap: 'var(--space-2)', alignItems: 'center' }}>
      <Select.Root value={format} onValueChange={(val) => setFormat(val as 'csv' | 'json')}>
        <Select.Trigger
          className="btn btn-secondary btn-sm"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 'var(--space-2)',
            minWidth: 120,
          }}
        >
          <Select.Value />
          <Select.Icon>
            <ChevronDown size={14} strokeWidth={1.75} />
          </Select.Icon>
        </Select.Trigger>
        <Select.Portal>
          <Select.Content className="halo-select-content" position="popper" sideOffset={6}>
            <Select.Viewport>
              <Select.Item value="csv" className="halo-select-item">
                <Select.ItemText>CSV</Select.ItemText>
              </Select.Item>
              <Select.Item value="json" className="halo-select-item">
                <Select.ItemText>JSON</Select.ItemText>
              </Select.Item>
            </Select.Viewport>
          </Select.Content>
        </Select.Portal>
      </Select.Root>

      <button
        onClick={handleExport}
        disabled={loading}
        className="btn btn-primary btn-sm"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--space-1)' }}
      >
        <Download size={14} strokeWidth={1.75} />
        {loading ? 'Exporting…' : 'Export'}
      </button>
    </div>
  );
}
